<template>
  <v-dialog
    max-width="600"
    :value="value"
    :persistent="loading"
    :no-click-animation="loading"
    @input="$emit('input:dialog', $event)"
  >
    <v-card class="nx-dashboard-shortcuts-manage-dialog">
      <v-card-title class="headline">{{ $t('message.dashboard.shortcuts.manageTitle') }}</v-card-title>
      <v-card-text>
        <v-list dense v-if="shortcuts.length > 0">
          <draggable handle=".drag-handle" v-model="shortcuts">
            <v-list-tile v-for="shortcut in shortcuts" :key="shortcut.id">
              <v-list-tile-avatar>
                <v-icon v-text="shortcut.icon"/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ shortcut.text | translate }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <div>
                  <v-btn icon color="primary--text" @click="removeShortcut(shortcut.id)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-btn icon color="primary--text" class="drag-handle">
                    <v-icon>drag_handle</v-icon>
                  </v-btn>
                </div>
              </v-list-tile-action>
            </v-list-tile>
          </draggable>
        </v-list>
        <v-flex v-else>
          <nx-dashboard-info-message
            :title="$t('message.dashboard.shortcuts.wizard.error.emptyShortcutsTitle')"
            :text="$t('message.dashboard.shortcuts.wizard.error.emptyShortcutsText')"
          />
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          flat
          :disabled="loading"
          @click="$emit('input:dialog', false)"
        >{{ $t('message.common.cancel') }}
        </v-btn>
        <v-btn color="secondary" flat :loading="loading" @click="saveShortcuts">
          {{ $t('message.common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import draggable from 'vuedraggable';
import NxDashboardInfoMessage from '@/modules/dashboard/components/DashboardInfoMessage.vue';

export default {
  name: 'nx-dashboard-shortcuts-manage-dialog',
  components: {
    NxDashboardInfoMessage,
    draggable,
  },
  props: {
    value: Boolean,
    cardId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      shortcuts: [],
    };
  },
  computed: {
    ...mapGetters('dashboard', ['getCardStaffPreferences']),
  },
  methods: {
    init() {
      const staffPreferences = this.getCardStaffPreferences(this.cardId);
      if (!staffPreferences
        || Array.isArray(staffPreferences)
        || typeof staffPreferences !== 'object'
        || !Array.isArray(staffPreferences.shortcuts)
      ) {
        this.shortcuts = [];
      } else {
        this.shortcuts = cloneDeep(staffPreferences.shortcuts);
      }
    },
    removeShortcut(shortcutId) {
      this.shortcuts = this.shortcuts.filter(shortcut => shortcut.id !== shortcutId);
    },
    async saveShortcuts() {
      await this.$store.dispatch('dashboard/SAVE_SHORTCUTS', {
        cardId: this.cardId,
        shortcuts: this.shortcuts,
      });
      this.$emit('input:dialog', false);
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.init();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="stylus">
@import '../../../../assets/stylus/variables.styl'

.nx-dashboard-shortcuts-manage-dialog {
  .v-list div[role=listitem]:not(.sortable-chosen) {
    border-bottom: 1px solid $primary;
  }

  .sortable-ghost {
    cursor: grab;
    opacity: .2;
    background-color: white
  }

  .sortable-chosen {
    background-color: white
  }

  .v-list__tile__action .v-btn--icon {
    margin: 0
  }
}
</style>
